module.exports = __webpack_public_path__ + "media/application/images/bonington_slider_watch-837b40da9cfe3f1bfd96440b5713efe9.png";